var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.requestLoading.length)?_c('div',{staticClass:"page-loading-container"},[_c('div',{staticClass:"page-loading"},[_vm._v(_vm._s(_vm.loadingMsg))])]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }